import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { transition } from "../../utils/transition";

export const containerStyle = recipe({
  base: {
    position: "absolute",
    pointerEvents: "none",
    padding: theme.spacings.m,
    width: "100%",
    transition: transition("padding-top"),
    selectors: {
      "&:empty": {
        display: "contents",
      },
      "&:before": {
        opacity: 0,
        transition: transition("opacity"),
      },
    },
  },
  variants: {
    moreThanOne: {
      true: {
        paddingTop: `calc(${theme.spacings.xl} + ${theme.spacings.xs})`,
        "&:before": {
          content: "''",
          position: "absolute",
          height: rem(200),
          maxWidth: rem(600),
          width: "100%",
          top: rem(-60),
          left: "50%",
          borderRadius: "999px",
          transform: "translateX(-50%)",
          background: `radial-gradient(circle, ${theme.colors.background}, transparent 80%, transparent)`,
          opacity: 1,
        },
      },
    },
  },
});

export const stackStyle = recipe({
  base: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const stackItemStyle = recipe({
  base: {
    height: "10px",
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transformOrigin: "center top",
  },
});

export const snackbarStyle = recipe({
  base: {
    top: 0,
    position: "absolute",
  },
});

export const buttonStyle = style({
  position: "absolute",
  top: theme.spacings.s,
  left: "50%",
  transform: "translateX(-50%)",
  pointerEvents: "auto",
  zIndex: 100,
});
